export default __webpack_public_path__ + "static/cubes-b49e147c9dbf3c60f8509df5dd79d498.gif";